import { Breakpoints } from '@/settings/breakpoints';

export const breakpoints = {
  [Breakpoints.NONE]: {
    slidesPerView: 1.1,
    spaceBetween: 12,
  },
  [Breakpoints.XXS]: {
    slidesPerView: 1.1,
    spaceBetween: 20,
  },
  [Breakpoints.XS]: {
    slidesPerView: 1.2,
    spaceBetween: 30,
  },
  [Breakpoints.MD]: {
    slidesPerView: 2.5,
    spaceBetween: 30,
  },
  [Breakpoints.LG]: {
    slidesPerView: 2.5,
    spaceBetween: 20,
  },
  [Breakpoints.XL]: {
    slidesPerView: 1.5,
    spaceBetween: 20,
  },
};
